import { REGIONS } from "../../data/content";
import { FadeUp, SectionHead, ChapterTag } from "./Reveal";

export default function Network() {
    return (
        <section id="network" className="scroll-mt-20 bg-navy-surface py-24 lg:py-32" data-testid="network-section">
            <div className="mx-auto max-w-[1440px] px-5 lg:px-10">
                <ChapterTag>Chapter 08 &mdash; Global Network</ChapterTag>

                <div className="mt-8 grid grid-cols-1 gap-14 lg:grid-cols-2 lg:gap-20">
                    <div>
                        <SectionHead
                            eyebrow="Our Reach"
                            title="Based in Mauritius. Connected Worldwide."
                            copy="Our teams and partners work across countries, languages and time zones. We combine local market understanding with international business experience to connect people, providers, products and opportunities."
                        />
                    </div>

                    <div>
                        {REGIONS.map((r, i) => (
                            <FadeUp key={r.name} delay={i * 0.06}>
                                <div
                                    className="flex flex-col gap-1 border-t border-white/10 py-5 transition-colors duration-500 hover:border-gold/30 sm:flex-row sm:items-baseline sm:justify-between"
                                    data-testid={`network-region-${r.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                                >
                                    <span className="font-serif text-xl font-normal text-ivory lg:text-2xl">{r.name}</span>
                                    <span className="text-xs uppercase tracking-[0.18em] text-gold/80">{r.role}</span>
                                </div>
                            </FadeUp>
                        ))}
                        <div className="border-t border-white/10" aria-hidden="true" />
                    </div>
                </div>
            </div>
        </section>
    );
}
